module.exports = __webpack_public_path__ + "img/memberbanner.ca155249.png";